<res-base-modal [modalTitle]="'Change Service for ' + titleBar" [modalClass]="'change-service-modal'"
    [modalAutomationId]="modalAutomationId" [primaryButtonLabel]="primaryButtonLabel" [maximizable]="true"
    [isPrimaryBtnEnabled]="isPrimaryBtnEnabled()" (primaryButtonActionEmt)="saveChanges()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Cancel'" [modalHelpIndex]="modalHelpIndex"
    [resizeHorizontal]="true" [resizeVertical]="true">

    <div id="left-section">
        <res-generic-grid #services [columnDefs]="columnDefs" [onSelectionChanged]="onSelectionChanged.bind(this)"
            [rowSelection]="rowSelection" [gridContext]="gridContext" [pagerVisible]="false"
            [automationId]="modalAutomationId + '-services-list'">
        </res-generic-grid>
    </div>
    <res-resizer anchor="left" resizingElementId="left-section" secondElementId="right-section" [collapsible]="false"
        [initSize]="62" [usePercentages]="true" [ellipsisExpander]="true"></res-resizer>
    <div id="right-section">
        <ul class="nav nav-tabs">
            <li [ngClass]="{'active': activeTable === ServiceTable.REALM_NODES }"
                data-automation-id="change-service-realm-nodes-tab" (click)="setTable(ServiceTable.REALM_NODES)">
                <a>Realm Nodes</a>
            </li>
            <li [ngClass]="{'active': activeTable === ServiceTable.PROJECTS }"
                data-automation-id="change-service-projects-tab" (click)="setTable(ServiceTable.PROJECTS)">
                <a>Projects</a>
            </li>
            <li [ngClass]="{'active': activeTable === ServiceTable.JOBS }" data-automation-id="change-service-jobs-tab"
                (click)="setTable(ServiceTable.JOBS)">
                <a>Jobs</a>
            </li>
        </ul>
        <res-generic-grid #realmnodes [hidden]="activeTable != ServiceTable.REALM_NODES" [pagerVisible]="false"
            [automationId]="modalAutomationId + '-right-list'" [collapsible]="false" [initSize]="450"
            [columnDefs]="realmColDefs">
        </res-generic-grid>
        <res-generic-grid #projects [hidden]="activeTable != ServiceTable.PROJECTS" [pagerVisible]="false"
            [automationId]="modalAutomationId + '-right-list'" [collapsible]="false" [initSize]="450"
            [columnDefs]="projectsColDefs" [requestInfo]="projectsRequestInfo" [responseCallback]="projectsCallback">
        </res-generic-grid>
        <res-generic-grid #jobs [hidden]="activeTable != ServiceTable.JOBS" [pagerVisible]="false" [collapsible]="false"
            [automationId]="modalAutomationId + '-right-list'" [initSize]="450" [columnDefs]="jobsColDefs">
        </res-generic-grid>
    </div>
</res-base-modal>